/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Itemnotfound_Title2Inputs */

const he_itemnotfound_title2 = /** @type {(inputs: Itemnotfound_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המוצר חמק מאיתנו!`)
};

const en_itemnotfound_title2 = /** @type {(inputs: Itemnotfound_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This product slipped away!`)
};

/**
* | output |
* | --- |
* | "This product slipped away!" |
*
* @param {Itemnotfound_Title2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const itemnotfound_title2 = /** @type {((inputs?: Itemnotfound_Title2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Itemnotfound_Title2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_itemnotfound_title2(inputs)
	return en_itemnotfound_title2(inputs)
});
export { itemnotfound_title2 as "itemNotFound_title" }